import { jsx as m } from "react/jsx-runtime";
import { DatePicker as g } from "../../../node_modules/react-datepicker/dist/index.es.mjs";
import { transformSecondsToDate as w, transformDateToSeconds as s } from "./utils.mjs";
import { generatePlaceholderFromFormat as F } from "../utills/generate-placeholder-for-format.mjs";
import { transformSioDateFormatToDatePicker as P } from "../utills/transform-sio-date-format-to-date-picker.mjs";
import { twMerge as i } from "tailwind-merge";
import { flip as b, shift as T } from "../../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs";
import { FormInput as k } from "../../form-input/form-input.mjs";
import { useTranslation as y } from "../../../i18n/hooks.mjs";
const j = ({
  seconds: e,
  onChangeSeconds: n,
  containerClassName: l,
  userDateFormat: a,
  userTimeFormat: p,
  classNameCustomInput: c,
  wrapperClassName: f,
  showTimeSelect: d = !0,
  showTimeSelectOnly: u = !0,
  timeIntervals: h = 15,
  ...t
}) => {
  const { t: x } = y(), { timeFormat: o } = a && p ? P(p, a) : { timeFormat: "HH:mm" };
  return (
    // react-datepicker create a popup component as sibling which can cause "jumping" if parent has flex property
    /* @__PURE__ */ m("div", { className: i("w-min", l), children: /* @__PURE__ */ m(
      g,
      {
        disabled: t.disabled || t.isPreFetching,
        selected: typeof e == "number" ? w(e) : null,
        onChange: (r) => {
          r && n(s(r));
        },
        showPopperArrow: !1,
        showTimeSelect: d,
        showTimeSelectOnly: u,
        timeIntervals: h,
        timeCaption: x("public_pages_purchase.date_picker.time"),
        timeFormat: o,
        dateFormat: o,
        popperModifiers: [b(), T({ padding: 5, crossAxis: !0 })],
        placeholderText: F(o),
        customInput: /* @__PURE__ */ m(k, { className: i("w-32", c), ...t }),
        timeClassName: (r) => e === s(r) ? "text-brand-primary" : "text-text-primary",
        wrapperClassName: i("time-only", f)
      }
    ) })
  );
};
export {
  j as TimePicker
};
